import Master from "./Master";

const Specialization = (props) => {
  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const submitUrl = apiEndPoint + "/SPL/";
  const parentSource = apiEndPoint + "/SPLForSelect/";
  const getAllUrl = apiEndPoint + "/SPLAll/";
  const lobSource = apiEndPoint + "/LoBForSelect/";
  const deleteUrl = apiEndPoint + "/SPL/";

  const masterProps = {
    masterlabel: "Specialization",
    id: "posd-master",
    variant: "primary",
    submitUrl: submitUrl,
    getAllUrl: getAllUrl,
    deleteUrl: deleteUrl,
    primaryKey: "business_spl_id",
    newEntryForm: props?.newEntryForm === undefined ? true : props.newEntryForm,
    fields: [
      {
        label: "Name",
        props: { required: true },
        ref: "business_spl_name",
      },
      {
        label: "Parent",
        controlType: "select",
        props: { required: true },
        defaultLabel: "Select Parent Specialization",
        options: [
          {
            label: "Root",
            value: 0,
          },
        ],
        dataUrl: parentSource,
        ref: "parent_business_spl_id",
        tableValue: "parent_business_spl_name",
      },
      {
        label: "Line of Business",
        controlType: "select",
        props: { required: true },
        defaultLabel: "Select LoB",
        dataUrl: lobSource,
        ref: "lob_id",
        tableValue: "lob_name",
      },
    ],
  };
  return <Master {...masterProps} />;
};
export default Specialization;
